
import axios from 'axios';

// ─────────────────────────────────────────────────────────────────────────
//  MONTHLY REPORT
// ─────────────────────────────────────────────────────────────────────────

/**
 * Fetch the HR employee monthly work report.
 * GET HREmployeeDetails/GetHREMPDetailsReport?p_year=YYYY&p_month=M
 *
 * @param {string|number} year 
 * @param {string|number} month 
 * @returns {Promise<AxiosResponse>} 
 */
const GetHREMPDetailsReport = (year, month) => {
  return axios.get('HREmployeeDetails/GetHREMPDetailsReport', {
    params: {
      p_year: year,
      p_month: String(Number(month)),
    },
  });
};


const MonthlyReportService = {
  GetHREMPDetailsReport,
};

export default MonthlyReportService;